export const MAX_ITEMS_TO_DOWNLOAD_FILE = 10000;
